export default __webpack_public_path__ + "static/media/settings.ac5af174.svg";